import Api from "./globalApi";
import { i18n } from "../plugins/i18n";
const localisations = i18n[process.env.VUE_APP_LANGUAGE];

// TYPES
const CONTEXT = "CONTEXT";

const CONTEXT_ITEMS = "CONTEXT_ITEMS";
const CONTEXT_ITEMS_LOADED = "CONTEXT_ITEMS_LOADED";

const contextModule = {
    namespaced: true,
    state: () => ({
        context: {
            type: null,
            id: null,
        },
        contextItems: Object.create({}),
        contextItemsLoaded: null,
    }),
    mutations: {
        [CONTEXT](state, context) {
            state.context = context;
        },
        [CONTEXT_ITEMS](state, obj) {
            state.contextItems = obj;
        },
        [CONTEXT_ITEMS_LOADED](state, isContextItemsLoaded) {
            state.contextItemsLoaded = isContextItemsLoaded;
        },
    },
    actions: {
        readContextItems({ commit, rootState }) {
            return Api.GetContextItems(rootState.aoqnUserId).then((result) => {
                commit(CONTEXT_ITEMS, result.data);
                commit(CONTEXT_ITEMS_LOADED, true);

                // adding 'Select all...' section 
                // to the context selection dropdown 
                // to retrieve all data (no context id/type)
                if (rootState.isAdmin)
                    result.data.unshift({ id: null, type: null, name: localisations.SELECT_ALL });

                var contextId = result.data[0].id;
                var contextType = result.data[0].type;

                //if the current user isn't an admin, we load data straight away
                commit(CONTEXT, { id: contextId, type: contextType, updatedManually: false });
            });
        },
        // context object (id, type) setter
        setContext({ commit }, context) {
            return commit(CONTEXT, { ...context, updatedManually: false });
        },
    },
};

export default contextModule;